/**
 * @description: 门票管理
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="ticket-manage">
        <div class="list-tit" v-show="showTit">
            <ul class="clearfix">
                <li class="col-md-3" v-for="menuItem in menu" :key="menuItem.id">
                    <span class="col-md-10" @click="titClk(menuItem.id)">{{menuItem.name}}</span>
                </li>
            </ul>
        </div>
        <div class="list-con" v-show="!showTit">
            <!-- 门票类型 -->
            <div class="tkt-list" v-show="show1">
                <el-row>
                    <el-button class="jh-width130" @click="backFun">返回</el-button>
                </el-row>
                <h1>门票类型</h1>
                <p class="p-hint">注：显示顺序大的在显示端靠前</p>
                <el-row>
                    <el-button type="primary" class="pull-right" @click="tktAdd">新增门票类型</el-button>
                </el-row>
                <el-table
                    v-loading="loading"
                    element-loading-text="努力加载中，请稍后..."
                    element-loading-background="rgba(0, 0, 0, 0.6)"
                    :data="tkt_table">
                    <el-table-column prop="listorder" label="显示顺序"></el-table-column>
                    <el-table-column prop="name" label="类型"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <span class="text-blue" @click="tktModify(scope.row)">修改</span>
                            <span class="text-blue" @click="tktDel(scope.row.id)">删除</span>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :page-size="GLOBAL.PAGESIZE"
                    :current-page.sync="tkt_page"
                    :total="tkt_total"
                    @current-change="getTktTable">
                </el-pagination>
                <!-- 新增、修改 -->
                <div class="tkt-edit-alert" ref="tkt_edit_alert">
                    <el-form :model="tkt_edit_form" label-width="120px">
                        <el-form-item label="显示顺序">
                            <el-input placeholder="请输入显示顺序" v-model="tkt_edit_form.listorder"></el-input>
                        </el-form-item>
                        <el-form-item label="类型名称">
                            <el-input placeholder="请输入类型名称" v-model="tkt_edit_form.name"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </div>



            <!-- 门票列表 -->
            <div class="mpl-list" v-show="show2 && !showMplEdit">
                <el-row>
                    <el-button class="jh-width130" @click="backFun">返回</el-button>
                </el-row>
                <h1>门票列表</h1>
                <el-form :inline="true" :model="mpl_list_form">
                    <el-form-item label="门店">
                        <el-select v-model="mpl_list_form.shop_id" filterable placeholder="请选择门店">
                            <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="门票类型">
                        <el-select v-model="mpl_list_form.category_id" filterable clearable placeholder="请选择门票类型">
                            <el-option v-for="item in ticket_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="推荐门票">
                        <el-select v-model="mpl_list_form.recommend" clearable placeholder="是否推荐门票">
                            <el-option label="是" value="1"></el-option>
                            <el-option label="否" value="-1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-select v-model="mpl_list_form.status" clearable placeholder="请选择状态">
                            <el-option label="启用" value="1"></el-option>
                            <el-option label="禁用" value="-1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="门票名称">
                        <el-input placeholder="请输入门票名称" v-model="mpl_list_form.name"></el-input>
                    </el-form-item>
                    <el-form-item class="pull-right">
                        <el-button type="primary" @click="mplAdd">新增门票</el-button>
                        <!-- <el-button type="primary">导出</el-button> -->
                        <el-button type="primary" @click="getMplTable(1)">查询</el-button>
                    </el-form-item>
                </el-form>
                <el-table
                    v-loading="loading"
                    element-loading-text="努力加载中，请稍后..."
                    element-loading-background="rgba(0, 0, 0, 0.6)"
                    :data="mpl_table">
                    <el-table-column prop="listorder" label="显示顺序"></el-table-column>
                    <el-table-column prop="shop_name" label="门店"></el-table-column>
                    <el-table-column prop="name" label="门票名称"></el-table-column>
                    <el-table-column prop="category_name" label="门票类型"></el-table-column>
                    <el-table-column prop="cost_price" label="原价"></el-table-column>
                    <el-table-column prop="discount_price" label="售价"></el-table-column>
                    <el-table-column prop="recommend" label="推荐门票">
                        <template slot-scope="scope">
                            {{scope.row.recommend == '1' ? '是' : '否'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="status" label="状态">
                        <template slot-scope="scope">
                            {{scope.row.status == '1' ? '启用' : '禁用'}}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <span class="text-blue" @click="mplModify(scope.row.id)">修改</span>
                            <span class="text-blue" @click="mplStatus(scope.row.id, -(scope.row.status))">
                                {{scope.row.status == '1' ? '禁用' : '启用'}}
                            </span>
                            <span class="text-blue" @click="mplStatus(scope.row.id, -2)">删除</span>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :page-size="GLOBAL.PAGESIZE"
                    :current-page.sync="mpl_page"
                    :total="mpl_total"
                    @current-change="getMplTable">
                </el-pagination>
            </div>
            <div class="mpl-edit" v-show="showMplEdit">
                <h2>{{mpl_edit_tit}}</h2>
                <el-form :model="mpl_edit_form" label-width="160px">
                    <el-form-item label="门店">
                        <el-select v-model="mpl_edit_form.shop_id" filterable placeholder="请选择门店">
                            <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="门票名称">
                        <el-input placeholder="请输入门票名称" v-model="mpl_edit_form.name"></el-input>
                    </el-form-item>
                    <el-form-item label="门票类型">
                        <el-select v-model="mpl_edit_form.category_id" filterable clearable placeholder="请选择门票类型">
                            <el-option v-for="item in ticket_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="原价">
                        <el-input placeholder="填写原价，用于被划线价格" v-model="mpl_edit_form.cost_price"></el-input>
                    </el-form-item>
                    <el-form-item label="售价">
                        <el-input placeholder="填写实际售卖价" v-model="mpl_edit_form.discount_price"></el-input>
                    </el-form-item>
                    <el-form-item label="显示顺序">
                        <el-input placeholder="请输入显示顺序" v-model="mpl_edit_form.listorder"></el-input>
                        <el-popover
                            placement="right"
                            trigger="hover">
                            <p>APP端显示时大的显示靠前</p>
                            <i class="el-icon-question my-el-hint" slot="reference"></i>
                        </el-popover>
                    </el-form-item>
                    <el-form-item label="是否推荐">
                        <el-select v-model="mpl_edit_form.recommend" placeholder="是否推荐">
                            <el-option label="是" value="1"></el-option>
                            <el-option label="否" value="-1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="是否打折">
                        <el-select v-model="mpl_edit_form.discount_status" placeholder="是否打折">
                            <el-option label="是" value="1"></el-option>
                            <el-option label="否" value="-1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="闯关主题">
                        <el-select v-model="mpl_edit_form.theme_id" filterable clearable placeholder="请选择闯关主题">
                            <el-option v-for="item in mpl_edit_theme" :key="item.theme_id" :label="item.theme_name" :value="item.theme_id"></el-option>
                        </el-select>
                        <el-popover
                            placement="right"
                            trigger="hover">
                            <p>门票核验完成后，公众号推送相应主题的闯关地图</p>
                            <i class="el-icon-question my-el-hint" slot="reference"></i>
                        </el-popover>
                    </el-form-item>
                    <el-form-item label="门票封面及详情素材">
                        <el-row>
                            <el-button type="primary" id="mplUploadBtn">上传图片/视频</el-button>
                            <span>图片尺寸：1300*1220</span>
                        </el-row>
                        <el-row class="clearfix">
                            <div class="mpl-edit-imgs" v-for="(item, index) in mpl_edit_form.resources" :key="index">
                                <img :src="item">
                                <i class="el-icon-error" @click="mplEditImgDel(index)"></i>
                            </div>
                        </el-row>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="showMplEdit=false">返回</el-button>
                        <el-button type="primary" @click="mplEdit">确定</el-button>
                    </el-form-item>
                </el-form>
            </div>



            <!-- 门票套餐类型 -->
            <div class="tkp-list" v-show="show3">
                <el-row>
                    <el-button class="jh-width130" @click="backFun">返回</el-button>
                </el-row>
                <h1>门票套餐类型</h1>
                <p>注：显示顺序大的在显示端靠前</p>
                <el-row>
                    <el-button type="primary" class="pull-right" @click="tkpAdd">新增门票套餐类型</el-button>
                </el-row>
                <el-table
                    v-loading="loading"
                    element-loading-text="努力加载中，请稍后..."
                    element-loading-background="rgba(0, 0, 0, 0.6)"
                    :data="tkp_table">
                    <el-table-column prop="listorder" label="显示顺序"></el-table-column>
                    <el-table-column prop="name" label="类型"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <span class="text-blue" @click="tkpModify(scope.row)">修改</span>
                            <span class="text-blue" @click="tkpDel(scope.row.id)">删除</span>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :page-size="GLOBAL.PAGESIZE"
                    :current-page.sync="tkp_page"
                    :total="tkp_total"
                    @current-change="getTkpTable">
                </el-pagination>
                <!-- 新增、修改 -->
                <div class="tkp-edit-alert" ref="tkp_edit_alert">
                    <el-form :model="tkp_edit_form" label-width="120px">
                        <el-form-item label="显示顺序">
                            <el-input placeholder="请输入显示顺序" v-model="tkp_edit_form.listorder"></el-input>
                        </el-form-item>
                        <el-form-item label="类型名称">
                            <el-input placeholder="请输入类型名称" v-model="tkp_edit_form.name"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </div>



            <!-- 门票套餐列表 -->
            <div class="mtl-list" v-show="show4 && !showMtlEdit">
                <el-row>
                    <el-button class="jh-width130" @click="backFun">返回</el-button>
                </el-row>
                <h1>门票套餐列表</h1>
                <el-form :inline="true" :model="mtl_list_form">
                    <el-form-item label="门店">
                        <el-select v-model="mtl_list_form.shop_id" filterable placeholder="请选择门店">
                            <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="套餐类型">
                        <el-select v-model="mtl_list_form.category_id" filterable clearable placeholder="请选择套餐类型">
                            <el-option v-for="item in ticket_package_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="推荐套餐">
                        <el-select v-model="mtl_list_form.recommend" clearable placeholder="是否推荐套餐">
                            <el-option label="是" value="1"></el-option>
                            <el-option label="否" value="-1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-select v-model="mtl_list_form.status" clearable placeholder="请选择状态">
                            <el-option label="启用" value="1"></el-option>
                            <el-option label="禁用" value="-1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="套餐名称">
                        <el-input placeholder="请输入套餐名称" v-model="mtl_list_form.name"></el-input>
                    </el-form-item>
                    <el-form-item class="pull-right">
                        <el-button type="primary" @click="mtlAdd">新增门票套餐</el-button>
                        <!-- <el-button type="primary">导出</el-button> -->
                        <el-button type="primary" @click="getMtlTable(1)">查询</el-button>
                    </el-form-item>
                </el-form>
                <el-table
                    v-loading="loading"
                    element-loading-text="努力加载中，请稍后..."
                    element-loading-background="rgba(0, 0, 0, 0.6)"
                    :data="mtl_table">
                    <el-table-column prop="listorder" label="显示顺序"></el-table-column>
                    <el-table-column prop="shop_name" label="门店"></el-table-column>
                    <el-table-column prop="name" label="套餐名称"></el-table-column>
                    <el-table-column prop="category_name" label="套餐类型"></el-table-column>
                    <el-table-column prop="cost_price" label="原价"></el-table-column>
                    <el-table-column prop="discount_price" label="售价"></el-table-column>
                    <el-table-column prop="recommend" label="推荐套餐">
                        <template slot-scope="scope">
                            {{scope.row.recommend == '1' ? '是' : '否'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="status" label="状态">
                        <template slot-scope="scope">
                            {{scope.row.status == '1' ? '启用' : '禁用'}}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="133">
                        <template slot-scope="scope">
                            <span class="text-blue" @click="mtlModify(scope.row.id)">修改</span>
                            <span class="text-blue" @click="mtlStatus(scope.row.id, -(scope.row.status))">
                                {{scope.row.status == '1' ? '禁用' : '启用'}}
                            </span>
                            <span class="text-blue" @click="mtlStatus(scope.row.id, -2)">删除</span>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :page-size="GLOBAL.PAGESIZE"
                    :current-page.sync="mtl_page"
                    :total="mtl_total"
                    @current-change="getMtlTable">
                </el-pagination>
            </div>
            <div class="mtl-edit" v-show="showMtlEdit">
                <h2>{{mtl_edit_tit}}</h2>
                <el-form :model="mtl_edit_form" label-width="160px">
                    <el-form-item label="门店">
                        <el-select v-model="mtl_edit_form.shop_id" filterable placeholder="请选择门店">
                            <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="套餐名称">
                        <el-input placeholder="请输入套餐名称" v-model="mtl_edit_form.name"></el-input>
                    </el-form-item>
                    <el-form-item label="套餐类型">
                        <el-select v-model="mtl_edit_form.category_id" filterable clearable placeholder="请选择套餐类型">
                            <el-option v-for="item in ticket_package_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="原价">
                        <el-input placeholder="填写原价，用于被划线价格" v-model="mtl_edit_form.cost_price"></el-input>
                    </el-form-item>
                    <el-form-item label="售价">
                        <el-input placeholder="填写实际售卖价" v-model="mtl_edit_form.discount_price"></el-input>
                    </el-form-item>
                    <el-form-item label="显示顺序">
                        <el-input placeholder="请输入显示顺序" v-model="mtl_edit_form.listorder"></el-input>
                        <el-popover
                            placement="right"
                            trigger="hover">
                            <p>APP端显示时大的显示靠前</p>
                            <i class="el-icon-question my-el-hint" slot="reference"></i>
                        </el-popover>
                    </el-form-item>
                    <el-form-item label="是否推荐">
                        <el-select v-model="mtl_edit_form.recommend" placeholder="是否推荐">
                            <el-option label="是" value="1"></el-option>
                            <el-option label="否" value="-1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="是否打折">
                        <el-select v-model="mtl_edit_form.discount_status" placeholder="是否打折">
                            <el-option label="是" value="1"></el-option>
                            <el-option label="否" value="-1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="财务分类营收金额设置">
                        <el-row class="cfs-edit-row">
                            <el-col>
                                <label class="el-form-item__label">门票收入</label>
                                <el-input placeholder="请输入金额" v-model="mtl_edit_form.ticket_price"></el-input>
                            </el-col>
                            <el-col>
                                <label class="el-form-item__label">A类酒水收入</label>
                                <el-input placeholder="请输入金额" v-model="mtl_edit_form.a_price"></el-input>
                            </el-col>
                        </el-row>
                        <el-row class="cfs-edit-row">
                            <el-col>
                                <label class="el-form-item__label">B类酒水收入</label>
                                <el-input placeholder="请输入金额" v-model="mtl_edit_form.b_price"></el-input>
                            </el-col>
                            <el-col>
                                <label class="el-form-item__label">C类酒水收入</label>
                                <el-input placeholder="请输入金额" v-model="mtl_edit_form.c_price"></el-input>
                            </el-col>
                        </el-row>
                        <el-row class="cfs-edit-row">
                            <el-col>
                                <label class="el-form-item__label">D类酒水收入</label>
                                <el-input placeholder="请输入金额" v-model="mtl_edit_form.d_price"></el-input>
                            </el-col>
                            <el-col>
                                <label class="el-form-item__label">房费收入</label>
                                <el-input placeholder="请输入金额" v-model="mtl_edit_form.time_price"></el-input>
                            </el-col>
                        </el-row>
                    </el-form-item>
                    <el-form-item label="套餐封面及详情素材">
                        <el-row>
                            <el-button type="primary" id="mtlUploadBtn">上传图片/视频</el-button>
                            <span>图片尺寸：1300*1220</span>
                        </el-row>
                        <el-row class="clearfix">
                            <div class="mtl-edit-imgs" v-for="(item, index) in mtl_edit_form.resources" :key="index">
                                <img :src="item">
                                <i class="el-icon-error" @click="mtlEditImgDel(index)"></i>
                            </div>
                        </el-row>
                    </el-form-item>
                    <el-form-item label="添加套餐明细">
                        <el-row>
                            <el-button type="primary" @click="mtlTicketsAdd">添加门票</el-button>
                            <el-button type="primary" @click="mtlGiftsAdd">添加赠送</el-button>
                        </el-row>
                        <label class="el-form-item__label">门票明细</label>
                        <el-table
                            :data="mtl_edit_form.wares_infos.ticket">
                            <el-table-column prop="relation_name" label="门票名称"></el-table-column>
                            <el-table-column prop="relation_type_name" label="门票类型"></el-table-column>
                            <el-table-column label="门票数量">
                                <template slot-scope="scope">
                                    <el-input placeholder="请输入正整数" v-model="mtl_edit_form.wares_infos.ticket[scope.$index].quantity" class="mtl-table-input" @blur="mtlTicketsQuantity($event, scope.$index, scope.row.quantity)"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作">
                                <template slot-scope="scope">
                                    <span class="text-blue" @click="mtlTicketsDel(scope.$index)">删除</span>
                                </template>
                            </el-table-column>
                        </el-table>
                        <label class="el-form-item__label">赠送明细</label>
                        <el-table
                            :data="mtl_edit_form.wares_infos.gift">
                            <el-table-column prop="relation_name" label="活动券名称"></el-table-column>
                            <el-table-column prop="relation_type_name" label="活动券类型"></el-table-column>
                            <el-table-column label="活动券数量">
                                <template slot-scope="scope">
                                    <el-input placeholder="请输入正整数" v-model="mtl_edit_form.wares_infos.gift[scope.$index].quantity" class="mtl-table-input" @blur="mtlGiftsQuantity($event, scope.$index, scope.row.quantity)"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作">
                                <template slot-scope="scope">
                                    <span class="text-blue" @click="mtlGiftsDel(scope.$index)">删除</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="showMtlEdit=false">返回</el-button>
                        <el-button type="primary" @click="mtlEdit">确定</el-button>
                    </el-form-item>
                </el-form>
            </div>



            <!-- 购票推荐商品列表 -->
            <div class="gtc-list" v-show="show5 && !showGtcEdit">
                <el-row>
                    <el-button class="jh-width130" @click="backFun">返回</el-button>
                </el-row>
                <h1>购票推荐商品列表</h1>
                <el-form :inline="true" :model="gtc_list_form">
                    <el-form-item label="门店">
                        <el-select v-model="gtc_list_form.shop_id" filterable placeholder="请选择门店">
                            <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="活动券类型">
                        <el-select v-model="gtc_list_form.type" clearable placeholder="请选择活动券类型">
                            <el-option label="优惠券" value="1"></el-option>
                            <el-option label="商品券" value="2"></el-option>
							<el-option label="商品套餐券" value="3"></el-option>
                            <el-option label="开房套餐券" value="4"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-select v-model="gtc_list_form.status" clearable placeholder="请选择状态">
                            <el-option label="启用" value="1"></el-option>
                            <el-option label="禁用" value="-1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="活动券名称">
                        <el-input placeholder="请输入活动券名称" v-model="gtc_list_form.name"></el-input>
                    </el-form-item>
                    <el-form-item class="pull-right">
                        <el-button type="primary" @click="gtcAdd">新增推荐商品</el-button>
                        <el-button type="primary" @click="getGtcTable(1)">查询</el-button>
                    </el-form-item>
                </el-form>
                <el-table
                    v-loading="loading"
                    element-loading-text="努力加载中，请稍后..."
                    element-loading-background="rgba(0, 0, 0, 0.6)"
                    :data="gtc_table">
                    <el-table-column prop="listorder" label="显示顺序"></el-table-column>
                    <el-table-column prop="shop_name" label="门店"></el-table-column>
                    <el-table-column prop="name" label="活动券名称"></el-table-column>
                    <el-table-column label="活动券类型">
                        <template slot-scope="scope">
                            <span v-if="scope.row.type=='1'">优惠券</span>
                            <span v-else-if="scope.row.type=='2'">商品券</span>
                            <span v-else-if="scope.row.type=='3'">商品套餐券</span>
                            <span v-else-if="scope.row.type=='4'">开房套餐券</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="适用日期">
                        <template slot-scope="scope">
                            {{scope.row.start_date + '~' + scope.row.end_date}}
                        </template>
                    </el-table-column>
                    <el-table-column label="适用时间">
                        <template slot-scope="scope">
                            {{scope.row.start_time + '~' + scope.row.end_time}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="week_cycle_str" label="有效星期几"></el-table-column>
                    <el-table-column prop="cost_price" label="原价"></el-table-column>
                    <el-table-column prop="discount_price" label="售价"></el-table-column>
                    <el-table-column prop="status" label="状态">
                        <template slot-scope="scope">
                            {{scope.row.status == '1' ? '启用' : '禁用'}}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <span class="text-blue" @click="gtcModify(scope.row)">修改</span>
                            <span class="text-blue" @click="gtcStatus(scope.row.id, -2)">删除</span>
                            <span class="text-blue" @click="gtcStatus(scope.row.id, -(scope.row.status))">
                                {{scope.row.status == '1' ? '禁用' : '启用'}}
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :page-size="GLOBAL.PAGESIZE"
                    :current-page.sync="gtc_page"
                    :total="gtc_total"
                    @current-change="getGtcTable">
                </el-pagination>
            </div>
            <div class="gtc-edit" v-show="showGtcEdit">
                <h2>{{gtc_edit_tit}}</h2>
                <el-form :model="gtc_edit_form" label-width="160px">
                    <el-form-item label="门店">
                        <el-select v-model="gtc_edit_form.shop_id" filterable placeholder="请选择门店">
                            <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="显示顺序">
                        <el-input placeholder="请输入显示顺序" v-model="gtc_edit_form.listorder"></el-input>
                        <el-popover
                            placement="right"
                            trigger="hover">
                            <p>APP端显示时大的显示靠前</p>
                            <i class="el-icon-question my-el-hint" slot="reference"></i>
                        </el-popover>
                    </el-form-item>
                    <el-form-item label="原价">
                        <el-input placeholder="填写原价，用于被划线价格" v-model="gtc_edit_form.cost_price"></el-input>
                    </el-form-item>
                    <el-form-item label="售价">
                        <el-input placeholder="填写实际售卖价" v-model="gtc_edit_form.discount_price"></el-input>
                    </el-form-item>
                    <el-form-item label="活动券">
                        <el-input v-model="gtc_edit_form.name" class="el-ellipsis" clearable placeholder="请选择活动券" @focus="gtcSelect" @clear="gtcDel"></el-input>
                    </el-form-item>
                    <el-form-item label="适用日期" class="gtc-usedate-wrap">
                        <div ref="gtc_usedate_main" class="gtc-usedate-main">
                            <el-input v-model="gtc_usedate_txt" class="el-ellipsis" placeholder="请选择适用日期"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item label="适用时间">
                        <el-input v-model="gtc_usetime_txt" class="el-ellipsis" placeholder="请选择适用时间" @click.native="gtcUsetime"></el-input>
                    </el-form-item>
                    <el-form-item label="有效星期几">
                        <el-input v-model="gtc_week_txt" class="el-ellipsis" clearable placeholder="请选择有效星期几" @focus="gtcWeekSelect" @clear="gtcWeekDel"></el-input>
                    </el-form-item>
                    <el-form-item label="财务分类收入明细设置">
                        <el-row class="cfs-edit-row">
                            <el-col>
                                <label class="el-form-item__label">门票收入</label>
                                <el-input placeholder="请输入金额" v-model="gtc_edit_form.ticket_settlement_price"></el-input>
                            </el-col>
                            <el-col>
                                <label class="el-form-item__label">A类酒水收入</label>
                                <el-input placeholder="请输入金额" v-model="gtc_edit_form.a_settlement_price"></el-input>
                            </el-col>
                        </el-row>
                        <el-row class="cfs-edit-row">
                            <el-col>
                                <label class="el-form-item__label">B类酒水收入</label>
                                <el-input placeholder="请输入金额" v-model="gtc_edit_form.b_settlement_price"></el-input>
                            </el-col>
                            <el-col>
                                <label class="el-form-item__label">C类酒水收入</label>
                                <el-input placeholder="请输入金额" v-model="gtc_edit_form.c_settlement_price"></el-input>
                            </el-col>
                        </el-row>
                        <el-row class="cfs-edit-row">
                            <el-col>
                                <label class="el-form-item__label">D类酒水收入</label>
                                <el-input placeholder="请输入金额" v-model="gtc_edit_form.d_settlement_price"></el-input>
                            </el-col>
                            <el-col>
                                <label class="el-form-item__label">房费收入</label>
                                <el-input placeholder="请输入金额" v-model="gtc_edit_form.time_settlement_price"></el-input>
                            </el-col>
                        </el-row>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="showGtcEdit=false">返回</el-button>
                        <el-button type="primary" @click="gtcEdit">确定</el-button>
                    </el-form-item>
                </el-form>
                <!-- 使用时间 -->
                <div class="use-time-wrap" ref="gtc_usetime_alert">
                    <h2>开始时间：</h2>
                    <el-row>
                        <el-col :span="11">
                            <el-select v-model="gtc_hour_start" filterable>
                                <el-option v-for="item in GLOBAL.HOURLIST" :key="item" :label="item" :value="item"></el-option>
                            </el-select>
                        </el-col>
                        <el-col class="el-line" :span="2">:</el-col>
                        <el-col :span="11">
                            <el-select v-model="gtc_minute_start" filterable>
                                <el-option v-for="item in GLOBAL.MINUTELIST" :key="item" :label="item" :value="item"></el-option>
                            </el-select>
                        </el-col>
                    </el-row>
                    <h2>结束时间：</h2>
                    <el-row>
                        <el-col :span="11">
                            <el-select v-model="gtc_hour_end" filterable>
                                <el-option v-for="item in GLOBAL.HOURLIST" :key="item" :label="item" :value="item"></el-option>
                            </el-select>
                        </el-col>
                        <el-col class="el-line" :span="2">:</el-col>
                        <el-col :span="11">
                            <el-select v-model="gtc_minute_end" filterable>
                                <el-option v-for="item in GLOBAL.MINUTELIST" :key="item" :label="item" :value="item"></el-option>
                            </el-select>
                        </el-col>
                    </el-row>
                </div>
                <!-- 星期 -->
                <div class="export-wrap" ref="gtc_week_alert">
                    <el-checkbox :indeterminate="gtc_week_sign" v-model="gtc_week_all" @change="gtcWeekAll">全选</el-checkbox>
                    <el-checkbox-group v-model="gtc_week_ids" @change="gtcWeekChange">
                        <el-checkbox label="1">星期一</el-checkbox>
                        <el-checkbox label="2">星期二</el-checkbox>
                        <el-checkbox label="3">星期三</el-checkbox>
                        <el-checkbox label="4">星期四</el-checkbox>
                        <el-checkbox label="5">星期五</el-checkbox>
                        <el-checkbox label="6">星期六</el-checkbox>
                        <el-checkbox label="0">星期日</el-checkbox>
                    </el-checkbox-group>
                </div>
            </div>



            <!-- 门票弹窗 -->
			<div class="select-goods-wrap" ref="ticket_alert">
				<el-row :gutter="20">
					<el-col :span="8">
						<el-select v-model="ticket_type" filterable clearable placeholder="请选择门票类型" @change="getTicketTable(1)">
                            <el-option v-for="item in ticket_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
					</el-col>
					<el-col :span="10">
						<el-input placeholder="请输入门票名称" v-model="ticket_name"></el-input>
					</el-col>
					<el-col :span="6">
						<el-button class="pull-right" type="primary" @click="getTicketTable(1)">查询</el-button>
					</el-col>
				</el-row>
				<el-table
					v-loading="loading"
					element-loading-text="努力加载中，请稍后..."
					element-loading-background="rgba(0, 0, 0, 0.6)"
					ref="ticket_table"
					:data="ticket_table"
					@selection-change="getTicketSelect">
					<el-table-column type="selection"></el-table-column>
					<el-table-column prop="category_name" label="类型"></el-table-column>
					<el-table-column prop="name" label="名称"></el-table-column>
				</el-table>
				<el-pagination
					background
					layout="total, prev, pager, next, jumper"
					:page-size="GLOBAL.PAGESIZEMINI"
					:current-page.sync="ticket_page"
					:total="ticket_total"
					@current-change="getTicketTable">
				</el-pagination>
			</div>
            <!-- 活动券弹窗 - 单选 -->
			<div class="select-goods-wrap" ref="csg_alert">
				<el-row :gutter="20">
					<el-col :span="8">
						<el-select v-model="csg_type" clearable filterable placeholder="请选择类型" @change="getCsgTable(1)">
							<el-option label="优惠券" value="1"></el-option>
                            <el-option label="商品券" value="2"></el-option>
							<el-option label="商品套餐券" value="3"></el-option>
                            <el-option label="开房套餐券" value="4"></el-option>
						</el-select>
					</el-col>
					<el-col :span="10">
						<el-input placeholder="请输入活动券名称" v-model="csg_name"></el-input>
					</el-col>
					<el-col :span="6">
						<el-button class="pull-right" type="primary" @click="getCsgTable(1)">查询</el-button>
					</el-col>
				</el-row>
				<el-table
					v-loading="loading"
					element-loading-text="努力加载中，请稍后..."
					element-loading-background="rgba(0, 0, 0, 0.6)"
					:data="csg_table">
					<el-table-column>
                        <template slot-scope="scope">
                            <el-radio v-model="csg_radio" :label="scope.$index" @change="getCsgRow(scope.row)">&nbsp;</el-radio>
                        </template>
                    </el-table-column>
					<el-table-column prop="type_name" label="类型"></el-table-column>
					<el-table-column prop="name" label="名称"></el-table-column>
				</el-table>
				<el-pagination
					background
					layout="total, prev, pager, next, jumper"
					:page-size="GLOBAL.PAGESIZEMINI"
					:current-page.sync="csg_page"
					:total="csg_total"
					@current-change="getCsgTable">
				</el-pagination>
			</div>
            <!-- 活动券弹窗 - 多选 -->
			<div class="select-goods-wrap" ref="coupon_alert">
				<el-row :gutter="20">
					<el-col :span="8">
						<el-select v-model="coupon_type" clearable filterable placeholder="请选择类型" @change="getCouponTable(1)">
							<el-option label="优惠券" value="1"></el-option>
                            <el-option label="商品券" value="2"></el-option>
							<el-option label="商品套餐券" value="3"></el-option>
                            <el-option label="开房套餐券" value="4"></el-option>
						</el-select>
					</el-col>
					<el-col :span="10">
						<el-input placeholder="请输入活动券名称" v-model="coupon_name"></el-input>
					</el-col>
					<el-col :span="6">
						<el-button class="pull-right" type="primary" @click="getCouponTable(1)">查询</el-button>
					</el-col>
				</el-row>
				<el-table
					v-loading="loading"
					element-loading-text="努力加载中，请稍后..."
					element-loading-background="rgba(0, 0, 0, 0.6)"
					ref="coupon_table"
					:data="coupon_table"
					@selection-change="getCouponSelect">
					<el-table-column type="selection"></el-table-column>
					<el-table-column prop="type_name" label="类型"></el-table-column>
					<el-table-column prop="name" label="名称"></el-table-column>
				</el-table>
				<el-pagination
					background
					layout="total, prev, pager, next, jumper"
					:page-size="GLOBAL.PAGESIZEMINI"
					:current-page.sync="coupon_page"
					:total="coupon_total"
					@current-change="getCouponTable">
				</el-pagination>
			</div>

        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                showTit: true,
                show1: false,
                show2: false,
                show3: false,
                show4: false,
                show5: false,
                loading: false,
                shop_list: [],
                ticket_type_list: [],
                ticket_package_type_list: [],
				week_list: [{id: "1", name: "一"}, {id: "2", name: "二"}, {id: "3", name: "三"}, {id: "4", name: "四"}, {id: "5", name: "五"}, {id: "6", name: "六"}, {id: "0", name: "日"}],
                // 门票弹窗
                ticket_shop_id: '',
				ticket_type: '',
				ticket_name: '',
				ticket_page: 1,
				ticket_total: 0,
                ticket_table: [],
                ticket_table_select: [],
                // 活动券弹窗 - 单选
                csg_shop_id: '',
				csg_type: '',
				csg_name: '',
				csg_page: 1,
				csg_total: 0,
                csg_table: [],
                csg_radio: '',
                csg_table_select: {},
                // 活动券弹窗 - 多选
                coupon_shop_id: '',
				coupon_type: '',
				coupon_name: '',
				coupon_page: 1,
				coupon_total: 0,
                coupon_table: [],
                coupon_table_select: [],

                // 门票类型
                tkt_page: 1,
				tkt_total: 0,
                tkt_table: [],
                tkt_edit_id: '',
                tkt_edit_form: {
                    listorder: '',
                    name: ''
                },

                // 门票列表
                showMplEdit: false,
                mpl_list_form: {
                    shop_id: '',
                    category_id: '',
                    recommend: '',
                    status: '',
                    name: ''
                },
                mpl_page: 1,
				mpl_total: 0,
                mpl_table: [],
                mpl_edit_id: '',
                mpl_edit_tit: '',
                mpl_edit_theme: [],
                mpl_edit_form: {
                    shop_id: '',
                    name: '',
                    category_id: '',
                    cost_price: '',
                    discount_price: '',
                    listorder: '',
                    recommend: [],
                    discount_status: '',
                    theme_id: '',
                    resources: []
                },

                // 门票套餐类型
                tkp_page: 1,
				tkp_total: 0,
                tkp_table: [],
                tkp_edit_id: '',
                tkp_edit_form: {
                    listorder: '',
                    name: ''
                },

                // 门票套餐列表
                showMtlEdit: false,
                mtl_list_form: {
                    shop_id: '',
                    category_id: '',
                    recommend: '',
                    status: '',
                    name: ''
                },
                mtl_page: 1,
				mtl_total: 0,
                mtl_table: [],
                mtl_edit_id: '',
                mtl_edit_tit: '',
                mtl_edit_form: {
                    shop_id: '',
                    name: '',
                    category_id: '',
                    cost_price: '',
                    discount_price: '',
                    listorder: '',
                    recommend: '',
                    discount_status: '',
                    ticket_price: '',
                    a_price: '',
                    b_price: '',
                    c_price: '',
                    d_price: '',
                    time_price: '',
                    resources: [],
                    wares_infos: {
                        ticket: [],
                        gift: []
                    }
                },

                // 购票推荐商品列表
                showGtcEdit: false,
                gtc_list_form: {
                    shop_id: '',
                    type: '',
                    status: '',
                    name: ''
                },
                gtc_page: 1,
				gtc_total: 0,
                gtc_table: [],
                gtc_edit_id: '',
                gtc_edit_tit: '',
                gtc_edit_form: {
                    shop_id: '',
                    listorder: '',
                    cost_price: '',
                    discount_price: '',
                    name: '',
                    gift_id: '',
                    type: '',
                    ticket_settlement_price: '',
                    a_settlement_price: '',
                    b_settlement_price: '',
                    c_settlement_price: '',
                    d_settlement_price: '',
                    time_settlement_price: ''
                },
                gtc_usedate_txt: '',
				gtc_usedate_start: '',
                gtc_usedate_end: '',
                gtc_usetime_txt: '',
                gtc_usetime_start: '',
                gtc_usetime_end: '',
                gtc_hour_start: '00',
                gtc_minute_start: '00',
                gtc_hour_end: '00',
                gtc_minute_end: '00',
                gtc_week_txt: '',
				gtc_week_sign: false,
				gtc_week_all: false,
				gtc_week_ids: [],
            }
        },
        computed: {
            menu() {
                let menu = {};
                if(!$.isEmptyObject(this.$store.state.menunew)) {
                    menu = JSON.parse(this.$store.state.menunew);
                    menu.forEach(_ => {
                        if(_.id == '1215') { // 门票
                            menu = _.submenu;
                            menu.forEach(v => {
                                if(v.id == '1217') { // 门票管理
                                    menu = v.submenu;
                                }
                            })
                        }
                    })
                }
                return menu;
            },
        },
        created: function() {
            this.getShop()
            this.getTicketType()
        },
        mounted: function() {
            this.mplImgUpload();
            this.mtlImgUpload();
        },
        methods: {
            titClk: function(menu_id) {
                const _this = this

                _this.showTit = false
                _this.show1 = false
                _this.show2 = false
                _this.show3 = false
                _this.show4 = false
                _this.show5 = false
                if(menu_id == '1223') { // 门票类型
                    _this.getTktTable(1)
                    _this.show1 = true
                } else if(menu_id == '1224') { // 门票列表
                    _this.mpl_list_form.shop_id = _this.shop_list[0].id
                    _this.getMplTable(1)
                    _this.show2 = true
                } else if(menu_id == '1225') { // 门票套餐类型
                    _this.getTkpTable(1)
                    _this.show3 = true
                } else if(menu_id == '1226') { // 门票套餐列表
                    _this.mtl_list_form.shop_id = _this.shop_list[0].id
                    _this.getMtlTable(1)
                    _this.show4 = true
                    _this.getTicketPackageType();
                } else if(menu_id == '1227') { // 购票推荐商品列表
                    _this.gtc_list_form.shop_id = _this.shop_list[0].id
                    _this.getGtcTable(1)
                    _this.show5 = true
                    _this.initDate()
                }
            },
            backFun: function() {
                this.showTit = true
                this.show1 = false
                this.show2 = false
                this.show3 = false
                this.show4 = false
                this.show5 = false
            },
            // 获取门店
            getShop: function() {
                const _this = this;

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result;
                        _this.shop_list.shift();
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
            // 获取主题
            getShopTheme(shop_id, resolve) {
                const _this = this

                Vue.axios.post('BistroLevels/getBistroThemeSearchList', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.mpl_edit_theme = res.data.response.result
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this)
                        layer.msg(res.data.response.error_msg)
                    }
                })
                .catch(err => {
                    layer.msg('出错啦')
                })
            },
            // 获取门票类型
            getTicketType() {
                const _this = this;

                Vue.axios.post('publicData/api_getTicketCategory', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "type": 1
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.ticket_type_list = res.data.response.result;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
            // 获取门票套餐类型
            getTicketPackageType() {
                const _this = this;

                Vue.axios.post('publicData/api_getTicketCategory', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "type": 2
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.ticket_package_type_list = res.data.response.result;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
            // 门票
			getTicketTable: function(page) {
				const _this = this;

				_this.loading = true;
                Vue.axios.post('Ticket/getList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
                            "page_size": _this.GLOBAL.PAGESIZEMINI,
                            "type": 1,
                            "shop_id": _this.ticket_shop_id,
                            "category_id": _this.ticket_type,
                            "status": 1,
                            "name": _this.ticket_name
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.ticket_total = Number(res.data.response.result.total);
						}
						_this.ticket_table = res.data.response.result.rows;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},
            // 活动券 - 单选
			getCsgTable: function(page) {
				const _this = this;

				_this.loading = true;
                Vue.axios.post('MerchantGift/getListToTicket', {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZEMINI,
							"shop_id": _this.csg_shop_id,
							"type": _this.csg_type,
							"name": _this.csg_name
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.csg_total = Number(res.data.response.result.total);
						}
						_this.csg_table = res.data.response.result.rows;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},
            // 活动券 - 多选
			getCouponTable: function(page) {
				const _this = this;

				_this.loading = true;
                Vue.axios.post('MerchantGift/getListToTicket', {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZEMINI,
							"shop_id": _this.coupon_shop_id,
							"type": _this.coupon_type,
							"name": _this.coupon_name
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.coupon_total = Number(res.data.response.result.total);
						}
						_this.coupon_table = res.data.response.result.rows;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },
            // 日期
			initDate: function() {
                const _this = this;

                $(_this.$refs.gtc_usedate_main).daterangepicker({
                    parentEl: '.gtc-usedate-wrap',
                    drops: 'up',
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                }, function(start, end, label) {
                    event.preventDefault()
                    _this.gtc_usedate_start = start.format('YYYY-MM-DD')
                    _this.gtc_usedate_end = end.format('YYYY-MM-DD')
                    _this.gtc_usedate_txt = _this.gtc_usedate_start + ' ~ ' + _this.gtc_usedate_end
                });
			},



            /*
             * 门票类型
             */
            // 列表
			getTktTable: function(page) {
				const _this = this;

				_this.loading = true;
				Vue.axios.post('Ticket/getCategoryList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "type": 1
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.tkt_total = Number(res.data.response.result.total);
						}
						_this.tkt_table = res.data.response.result.rows;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },
            // 删除
			tktDel(id) {
				const _this = this;

				layer.confirm('删除后不可恢复，确定删除吗？', {
					btn: ['确定', '取消']
				}, function() {
					Vue.axios.post('Ticket/delCategoryData', {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
								"id": id
							}
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.msg('删除成功');
							_this.getTktTable(_this.tkt_page);
                            _this.getTicketType()
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg('出错啦');
					});
				});
            },
            // 点击新增
			tktAdd() {
                this.tkt_edit_id = ''
                this.tkt_edit_form = {
                    listorder: '',
                    name: ''
                }
                this.tktEdit('新增门票类型')
			},
			// 点击修改
			tktModify(row) {
                this.tkt_edit_id = row.id
                this.tkt_edit_form = {
                    listorder: row.listorder,
                    name: row.name
                }
                this.tktEdit('修改门票类型')
            },
            // 新增、修改
			tktEdit(tit) {
                const _this = this;

                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: [tit, true],
                    area: ['600px', ''], // 宽高
                    content: $(_this.$refs.tkt_edit_alert)
                }, function() {
                    let url = "Ticket/addCategoryData";
                    let data = {
                        "header": Vue.request_header,
                        "request": {
                            "param": {
                                "type": 1,
                                "listorder": _this.tkt_edit_form.listorder,
                                "name": _this.tkt_edit_form.name
                            }
                        },
                        "comment": ""
                    };
                    if(_this.tkt_edit_id) {
                        data.request.param.id = _this.tkt_edit_id;
                        url = "Ticket/editCategoryData";
                    }
                    Vue.axios({
                        method: 'post',
                        url: url,
                        data: data
                    })
                    .then(res => {
                        if(res.data.response.result_code == "true") {
                            layer.msg('操作成功')
                            _this.getTktTable(_this.tkt_page)
                            _this.getTicketType()
                            layer.closeAll()
                        } else {
                            Vue.timeoutfun(res.data.response.result_status, _this);
                            layer.msg(res.data.response.error_msg);
                        }
                    })
                    .catch(err => {
                        layer.msg("出错啦");
                    });
                });
            },



            /*
             * 门票列表
             */
            // 更改门店
            mplEditShop(val) {
                new Promise(resolve => {
                    this.getShopTheme(val, resolve)
                })
            },
            // 列表
			getMplTable: function(page) {
				const _this = this;

				_this.loading = true;
				Vue.axios.post('Ticket/getList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "type": 1,
                            "shop_id": _this.mpl_list_form.shop_id,
                            "category_id": _this.mpl_list_form.category_id,
                            "recommend": _this.mpl_list_form.recommend,
                            "status": _this.mpl_list_form.status,
                            "name": _this.mpl_list_form.name
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.mpl_total = Number(res.data.response.result.total);
						}
						_this.mpl_table = res.data.response.result.rows;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },
            // 启用禁用删除
			mplStatus(id, status) {
				const _this = this;

				layer.confirm('确定执行该操作吗？', {
					btn: ['确定', '取消']
				}, function() {
					Vue.axios.post('Ticket/updateStatuaData', {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
                                "id": id,
                                "status": status
							}
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.msg('操作成功');
							_this.getMplTable(_this.mpl_page);
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg('出错啦');
					});
				});
            },
            // 上传图片/视频
			mplImgUpload: function() {
				let _this = this;
				let host = '',
					dir = '',
                    file_name = '',
                    OSSAccessKeyId = '',
                    policy = '',
                    signature = '';

                let tm_loading = {};

				setTimeout(function() {
					// 实例化一个plupload上传对象
					let uploader = new plupload.Uploader({
						browse_button: 'mplUploadBtn', // 选择文件id
						filters: {
							mime_types: [ // 文件格式限制
								{ title: "files", extensions: "jpg,jpeg,png,gif,mp4,mkv" }
							],
							// max_file_size: '2mb', // 文件大小限制
							// prevent_duplicates: true // 不允许选取重复文件
						},
						resize: {
							width: 1300,
							height: 1220
						},
						multi_selection: false, // 单选
						url: './', // OSS地址
						init: {
							// 当队列中的某一个文件正要开始上传前触发监听函数参数
							BeforeUpload: function(up, file) {},
							// 文件选择完毕触发
							FilesAdded: function(up, files) {
                                // 获取签名
								Vue.axios.post('publicData/api_getOssSignature', {
									"header": Vue.request_header,
									"request": {
										"version": Vue.version,
										"param": {
											"file": files[0].name,
											"path": 'ticket_system'
										}
									},
									"comment": ""
								})
								.then(res => {
									if(res.data.response.result_code == "true") {
										host = res.data.response.data.host
										dir = res.data.response.data.dir
                                        file_name = res.data.response.data.file_name
                                        OSSAccessKeyId = res.data.response.data.accessid
                                        policy = res.data.response.data.policy
                                        signature = res.data.response.data.signature
										const new_params = {
											'key': dir + file_name,
											'OSSAccessKeyId': OSSAccessKeyId,
											'policy': policy,
											'signature': signature,
											'success_action_status': '200', // 让服务端返回200，不然，默认会返回204
										};
										up.setOption({
											'url': host,
											'multipart_params': new_params
										});

                                        // 上传文件
                                        uploader.start();
                                        // loading
                                        tm_loading = _this.$loading({
                                            lock: true,
                                            text: '上传中，请稍后...',
                                            spinner: 'el-icon-loading',
                                            background: 'rgba(0, 0, 0, 0.7)'
                                        })
									} else {
										Vue.timeoutfun(data.response.result_status, _this);
										layer.msg(data.response.error_msg);
									}
								})
								.catch(err => {
									layer.msg("出错啦");
								});
                            },
                            // 文件上传过程中
                            UploadProgress: function(up, file) {},
							// 文件上传成功触发
							FileUploaded: function(up, file, data) {
                                tm_loading.close()
								_this.mpl_edit_form.resources.push(host + "/" + dir + file_name)
								layer.msg('上传成功');
							},
							// 错误提示
							Error: function(up, err) {
								if(err.code == -600) {
									layer.msg('请选择2mb以内的文件');
								} else if (err.code == -601) {
									layer.msg('只允许上传jpg,jpeg,png,gif,mp4,mkv文件');
								} else if (err.code == -602) {
									layer.msg('这个文件已经上传过一遍了');
								} else {
									layer.msg(err.response);
                                }
                                tm_loading.close()
							}
						}
					});
					// 初始化
					uploader.init();
				}, 20);
            },
            // 删除图片/视频
            mplEditImgDel(index) {
                this.mpl_edit_form.resources.splice(index, 1);
            },
            // 点击新增
			mplAdd() {
                this.mpl_edit_id = ''
                this.mpl_edit_tit = '新增门票'
                this.mpl_edit_form = {
                    shop_id: this.shop_list[0].id,
                    name: '',
                    category_id: '',
                    cost_price: '',
                    discount_price: '',
                    listorder: '',
                    recommend: '-1',
                    discount_status: '-1',
                    theme_id: '',
                    resources: []
                }
                new Promise(resolve => {
                    this.getShopTheme(this.shop_list[0].id, resolve)
                })
                this.showMplEdit = true
			},
			// 点击修改
			mplModify(id) {
                const _this = this;

                Vue.axios.post('Ticket/getData', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        const row = res.data.response.result;

                        _this.mpl_edit_id = row.id
                        _this.mpl_edit_tit = '修改门票'
                        _this.mpl_edit_form = {
                            shop_id: row.shop_id,
                            name: row.name,
                            category_id: row.category_id,
                            cost_price: row.cost_price,
                            discount_price: row.discount_price,
                            listorder: row.listorder,
                            recommend: row.recommend,
                            discount_status: row.discount_status,
                            theme_id: row.theme_id,
                            resources: row.resources.split(',')
                        }
                        new Promise(resolve => {
                            _this.getShopTheme(row.shop_id, resolve)
                        })
                        _this.mpl_edit_form.theme_id = row.theme_id
                        _this.showMplEdit = true
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                })
            },
            // 新增、修改
			mplEdit() {
                const _this = this;

                let url = "Ticket/addData"
                let data = {
                    "header": Vue.request_header,
					"request": {
						"param": {
                            "type": 1,
                            "shop_id": _this.mpl_edit_form.shop_id,
                            "name": _this.mpl_edit_form.name,
                            "category_id": _this.mpl_edit_form.category_id,
                            "cost_price": _this.mpl_edit_form.cost_price,
                            "discount_price": _this.mpl_edit_form.discount_price,
                            "listorder": _this.mpl_edit_form.listorder,
                            "recommend": _this.mpl_edit_form.recommend,
                            "discount_status": _this.mpl_edit_form.discount_status,
                            "theme_id": _this.mpl_edit_form.theme_id,
                            "resources": _this.mpl_edit_form.resources.join(',')
						}
					},
					"comment": ""
                }
                if(_this.mpl_edit_id) {
                    data.request.param.id = _this.mpl_edit_id;
                    url = "Ticket/editData";
                }
                Vue.axios({
                    method: 'post',
                    url: url,
                    data: data
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        layer.msg('操作成功')
						_this.getMplTable(_this.mpl_page)
						_this.showMplEdit = false
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                })
            },



            /*
             * 门票套餐类型
             */
            // 列表
			getTkpTable: function(page) {
				const _this = this;

				_this.loading = true;
				Vue.axios.post('Ticket/getCategoryList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "type": 2
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.tkp_total = Number(res.data.response.result.total);
						}
						_this.tkp_table = res.data.response.result.rows;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },
            // 删除
			tkpDel(id) {
				const _this = this;

				layer.confirm('删除后不可恢复，确定删除吗？', {
					btn: ['确定', '取消']
				}, function() {
					Vue.axios.post('Ticket/delCategoryData', {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
								"id": id
							}
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.msg('删除成功');
							_this.getTkpTable(_this.tkp_page);
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg('出错啦');
					});
				});
            },
            // 点击新增
			tkpAdd() {
                this.tkp_edit_id = ''
                this.tkp_edit_form = {
                    listorder: '',
                    name: ''
                }
                this.tkpEdit('新增门票套餐类型')
			},
			// 点击修改
			tkpModify(row) {
                this.tkp_edit_id = row.id
                this.tkp_edit_form = {
                    listorder: row.listorder,
                    name: row.name
                }
                this.tkpEdit('修改门票套餐类型')
            },
            // 新增、修改
			tkpEdit(tit) {
                const _this = this;

                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: [tit, true],
                    area: ['600px', ''], // 宽高
                    content: $(_this.$refs.tkp_edit_alert)
                }, function() {
                    let url = "Ticket/addCategoryData";
                    let data = {
                        "header": Vue.request_header,
                        "request": {
                            "param": {
                                "type": 2,
                                "listorder": _this.tkp_edit_form.listorder,
                                "name": _this.tkp_edit_form.name
                            }
                        },
                        "comment": ""
                    };
                    if(_this.tkp_edit_id) {
                        data.request.param.id = _this.tkp_edit_id;
                        url = "Ticket/editCategoryData";
                    }
                    Vue.axios({
                        method: 'post',
                        url: url,
                        data: data
                    })
                    .then(res => {
                        if(res.data.response.result_code == "true") {
                            layer.closeAll()
                            layer.msg('操作成功')
                            _this.getTkpTable(_this.tkp_page)
                        } else {
                            Vue.timeoutfun(res.data.response.result_status, _this);
                            layer.msg(res.data.response.error_msg);
                        }
                    })
                    .catch(err => {
                        layer.msg("出错啦");
                    });
                });
            },



            /*
             * 门票套餐列表
             */
			getMtlTable: function(page) {
				const _this = this;

				_this.loading = true;
				Vue.axios.post('Ticket/getList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "type": 2,
                            "shop_id": _this.mtl_list_form.shop_id,
                            "category_id": _this.mtl_list_form.category_id,
                            "recommend": _this.mtl_list_form.recommend,
                            "status": _this.mtl_list_form.status,
                            "name": _this.mtl_list_form.name
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.mtl_total = Number(res.data.response.result.total);
						}
						_this.mtl_table = res.data.response.result.rows;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },
            // 启用禁用删除
			mtlStatus(id, status) {
				const _this = this;

				layer.confirm('确定执行该操作吗？', {
					btn: ['确定', '取消']
				}, function() {
					Vue.axios.post('Ticket/updateStatuaData', {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
                                "id": id,
                                "status": status
							}
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.msg('操作成功');
							_this.getMtlTable(_this.mtl_page);
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg('出错啦');
					});
				});
            },
            // 上传图片/视频
			mtlImgUpload: function() {
				let _this = this;
				let host = '',
					dir = '',
                    file_name = '',
                    OSSAccessKeyId = '',
                    policy = '',
                    signature = '';

                let tm_loading = {};

				setTimeout(function() {
					// 实例化一个plupload上传对象
					let uploader = new plupload.Uploader({
						browse_button: 'mtlUploadBtn', // 选择文件id
						filters: {
							mime_types: [ // 文件格式限制
								{ title: "files", extensions: "jpg,jpeg,png,gif,mp4,mkv" }
							],
							// max_file_size: '2mb', // 文件大小限制
							// prevent_duplicates: true // 不允许选取重复文件
						},
						resize: {
							width: 1300,
							height: 1220
						},
						multi_selection: false, // 单选
						url: './', // OSS地址
						init: {
							// 当队列中的某一个文件正要开始上传前触发监听函数参数
							BeforeUpload: function(up, file) {},
							// 文件选择完毕触发
							FilesAdded: function(up, files) {
                                // 获取签名
								Vue.axios.post('publicData/api_getOssSignature', {
									"header": Vue.request_header,
									"request": {
										"version": Vue.version,
										"param": {
											"file": files[0].name,
											"path": 'ticket_system'
										}
									},
									"comment": ""
								})
								.then(res => {
									if(res.data.response.result_code == "true") {
										host = res.data.response.data.host
										dir = res.data.response.data.dir
                                        file_name = res.data.response.data.file_name
                                        OSSAccessKeyId = res.data.response.data.accessid
                                        policy = res.data.response.data.policy
                                        signature = res.data.response.data.signature
										const new_params = {
											'key': dir + file_name,
											'OSSAccessKeyId': OSSAccessKeyId,
											'policy': policy,
											'signature': signature,
											'success_action_status': '200', // 让服务端返回200，不然，默认会返回204
										};
										up.setOption({
											'url': host,
											'multipart_params': new_params
										});

                                        // 上传文件
                                        uploader.start();
                                        // loading
                                        tm_loading = _this.$loading({
                                            lock: true,
                                            text: '上传中，请稍后...',
                                            spinner: 'el-icon-loading',
                                            background: 'rgba(0, 0, 0, 0.7)'
                                        })
									} else {
										Vue.timeoutfun(data.response.result_status, _this);
										layer.msg(data.response.error_msg);
									}
								})
								.catch(err => {
									layer.msg("出错啦");
								});
                            },
                            // 文件上传过程中
                            UploadProgress: function(up, file) {},
							// 文件上传成功触发
							FileUploaded: function(up, file, data) {
                                tm_loading.close()
								_this.mtl_edit_form.resources.push(host + "/" + dir + file_name)
								layer.msg('上传成功');
							},
							// 错误提示
							Error: function(up, err) {
								if(err.code == -600) {
									layer.msg('请选择2mb以内的文件');
								} else if (err.code == -601) {
									layer.msg('只允许上传jpg,jpeg,png,gif,mp4,mkv文件');
								} else if (err.code == -602) {
									layer.msg('这个文件已经上传过一遍了');
								} else {
									layer.msg(err.response);
                                }
                                tm_loading.close()
							}
						}
					});
					// 初始化
					uploader.init();
				}, 20);
            },
            // 删除图片/视频
            mtlEditImgDel(index) {
                this.mtl_edit_form.resources.splice(index, 1);
            },
            // 添加门票
			mtlTicketsAdd: function() {
				const _this = this;

                _this.ticket_shop_id = _this.mtl_edit_form.shop_id
				_this.ticket_type = ''
				_this.ticket_name = ''
				_this.ticket_page = 1
				_this.getTicketTable(1)
				layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['添加门票', true],
                    area: ['700px', '500px'], // 宽高
                    content: $(_this.$refs.ticket_alert)
                }, function() {
                    // 保存门票
                    _this.ticket_table_select.forEach(_ => {
                        let isTrue = true;
                        for(let i = 0; i < _this.mtl_edit_form.wares_infos.ticket.length; i++) {
                            if(_this.mtl_edit_form.wares_infos.ticket[i].relation_id == _.id) {
                                isTrue = false
                                return false
                            }
                        }
                        if(isTrue) {
                            _this.mtl_edit_form.wares_infos.ticket.push({
                                relation_id: _.id,
                                relation_name: _.name,
                                relation_type: _.category_id,
                                relation_type_name: _.category_name,
                                quantity: 1
                            })
                        }
                    })
                    layer.msg('保存成功')
                    _this.$refs.ticket_table.clearSelection();
                });
			},
			mtlTicketsDel(i) {
				this.mtl_edit_form.wares_infos.ticket.splice(i, 1)
			},
			getTicketSelect(val) {
				this.ticket_table_select = val
            },
            mtlTicketsQuantity(val, i, quantity) {
                if(!/^[1-9]\d*$/.test(quantity)) {
                    layer.msg('请输入正整数')
                    this.mtl_edit_form.wares_infos.ticket[i].quantity = 1
                }
            },
            // 添加赠送
			mtlGiftsAdd: function() {
				const _this = this;

                _this.coupon_shop_id = _this.mtl_edit_form.shop_id
				_this.coupon_type = ''
				_this.coupon_name = ''
				_this.coupon_page = 1
				_this.getCouponTable(1)
				layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['添加活动券', true],
                    area: ['700px', '500px'], // 宽高
                    content: $(_this.$refs.coupon_alert)
                }, function() {
                    // 保存活动券
                    _this.coupon_table_select.forEach(_ => {
                        let isTrue = true;
                        for(let i = 0; i < _this.mtl_edit_form.wares_infos.gift.length; i++) {
                            if(_this.mtl_edit_form.wares_infos.gift[i].relation_id == _.id) {
                                isTrue = false
                                return false
                            }
                        }
                        if(isTrue) {
                            _this.mtl_edit_form.wares_infos.gift.push({
                                relation_id: _.id,
                                relation_name: _.name,
                                relation_type: _.type,
                                relation_type_name: _.type_name,
                                quantity: 1
                            })
                        }
                    })
                    layer.msg('保存成功')
                    _this.$refs.coupon_table.clearSelection();
                });
			},
			mtlGiftsDel(i) {
				this.mtl_edit_form.wares_infos.gift.splice(i, 1)
			},
			getCouponSelect(val) {
				this.coupon_table_select = val
            },
            mtlGiftsQuantity(val, i, quantity) {
                if(!/^[1-9]\d*$/.test(quantity)) {
                    layer.msg('请输入正整数')
                    this.mtl_edit_form.wares_infos.gift[i].quantity = 1
                }
            },
            // 点击新增
			mtlAdd() {
                this.mtl_edit_id = ''
                this.mtl_edit_tit = '新增门票套餐'
                this.mtl_edit_form = {
                    shop_id: this.shop_list[0].id,
                    name: '',
                    category_id: '',
                    cost_price: '',
                    discount_price: '',
                    listorder: '',
                    recommend: '-1',
                    discount_status: '-1',
                    ticket_price: '',
                    a_price: '',
                    b_price: '',
                    c_price: '',
                    d_price: '',
                    time_price: '',
                    resources: [],
                    wares_infos: {
                        ticket: [],
                        gift: []
                    }
                }
                this.showMtlEdit = true;
			},
			// 点击修改
			mtlModify(id) {
                const _this = this;

                Vue.axios.post('Ticket/getData', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        const row = res.data.response.result;

                        _this.mtl_edit_id = row.id
                        _this.mtl_edit_tit = '修改门票套餐'
                        _this.mtl_edit_form = {
                            shop_id: row.shop_id,
                            name: row.name,
                            category_id: row.category_id,
                            cost_price: row.cost_price,
                            discount_price: row.discount_price,
                            listorder: row.listorder,
                            recommend: row.recommend,
                            discount_status: row.discount_status,
                            ticket_price: row.ticket_price,
                            a_price: row.a_price,
                            b_price: row.b_price,
                            c_price: row.c_price,
                            d_price: row.d_price,
                            time_price: row.time_price,
                            resources: row.resources.split(','),
                            wares_infos: row.wares_infos
                        }
                        _this.showMtlEdit = true;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
            // 新增、修改
			mtlEdit() {
                const _this = this;

                let url = "Ticket/addData"
                let data = {
                    "header": Vue.request_header,
					"request": {
						"param": {
                            "type": 2,
                            "shop_id": _this.mtl_edit_form.shop_id,
                            "name": _this.mtl_edit_form.name,
                            "category_id": _this.mtl_edit_form.category_id,
                            "cost_price": _this.mtl_edit_form.cost_price,
                            "discount_price": _this.mtl_edit_form.discount_price,
                            "listorder": _this.mtl_edit_form.listorder,
                            "recommend": _this.mtl_edit_form.recommend,
                            "discount_status": _this.mtl_edit_form.discount_status,
                            "ticket_price": _this.mtl_edit_form.ticket_price,
                            "a_price": _this.mtl_edit_form.a_price,
                            "b_price": _this.mtl_edit_form.b_price,
                            "c_price": _this.mtl_edit_form.c_price,
                            "d_price": _this.mtl_edit_form.d_price,
                            "time_price": _this.mtl_edit_form.time_price,
                            "resources": _this.mtl_edit_form.resources.join(','),
                            "wares_infos": _this.mtl_edit_form.wares_infos
						}
					},
					"comment": ""
                }
                if(_this.mtl_edit_id) {
                    data.request.param.id = _this.mtl_edit_id;
                    url = "Ticket/editData";
                }
                Vue.axios({
                    method: 'post',
                    url: url,
                    data: data
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        layer.msg('操作成功')
						_this.getMtlTable(_this.mtl_page)
						_this.showMtlEdit = false
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                })
            },



            /*
             * 购票推荐商品列表
             */
			getGtcTable: function(page) {
				const _this = this;

				_this.loading = true;
				Vue.axios.post('Ticket/getRecommendGiftList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "shop_id": _this.gtc_list_form.shop_id,
                            "type": _this.gtc_list_form.type,
                            "status": _this.gtc_list_form.status,
                            "name": _this.gtc_list_form.name
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.gtc_total = Number(res.data.response.result.total);
						}
						_this.gtc_table = res.data.response.result.rows;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },
            // 启用禁用删除
			gtcStatus(id, status) {
				const _this = this;

				layer.confirm('确定执行该操作吗？', {
					btn: ['确定', '取消']
				}, function() {
					Vue.axios.post('Ticket/updateRecommendGiftStatuaData', {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
                                "id": id,
                                "status": status
							}
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.msg('操作成功');
							_this.getGtcTable(_this.gtc_page);
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg('出错啦');
					});
				});
            },
            // 选择活动券
			gtcSelect() {
				const _this = this;

                _this.csg_shop_id = _this.gtc_edit_form.shop_id
				_this.csg_type = ''
				_this.csg_name = ''
				_this.csg_page = 1
                _this.csg_radio = ''
				_this.getCsgTable(1)
				layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['添加活动券', true],
                    area: ['700px', '500px'], // 宽高
                    content: $(_this.$refs.csg_alert)
                }, function() {
                    // 保存活动券
                    _this.gtc_edit_form.name = _this.csg_table_select.name
                    _this.gtc_edit_form.gift_id = _this.csg_table_select.id
                    _this.gtc_edit_form.type = _this.csg_table_select.type
                    layer.closeAll()
                    // layer.msg('保存成功')
                });
			},
			gtcDel() {
				this.gtc_edit_form.name = ''
				this.gtc_edit_form.gift_id = ''
				this.gtc_edit_form.type = ''
            },
            getCsgRow(row) {
                this.csg_table_select = row
            },
            // 点击新增
			gtcAdd() {
                this.gtc_edit_id = ''
                this.gtc_edit_tit = '新增推荐商品'
                this.gtc_edit_form = {
                    shop_id: this.shop_list[0].id,
                    listorder: '',
                    cost_price: '',
                    discount_price: '',
                    name: '',
                    gift_id: '',
                    type: '',
                    ticket_settlement_price: '',
                    a_settlement_price: '',
                    b_settlement_price: '',
                    c_settlement_price: '',
                    d_settlement_price: '',
                    time_settlement_price: ''
                }
                this.gtc_usedate_txt = ''
				this.gtc_usedate_start = ''
                this.gtc_usedate_end = ''
				this.gtc_usetime_txt = ''
				this.gtc_usetime_start = ''
				this.gtc_usetime_end = ''
                this.gtc_week_txt = ''
                this.gtc_week_ids = []
                this.gtc_week_sign = false
                this.gtc_week_all = false
                this.showGtcEdit = true
			},
			// 点击修改
			gtcModify(row) {
                const _this = this;

                _this.gtc_edit_id = row.id
                _this.gtc_edit_tit = '修改推荐商品'
                _this.gtc_edit_form = {
                    shop_id: row.shop_id,
                    listorder: row.listorder,
                    cost_price: row.cost_price,
                    discount_price: row.discount_price,
                    name: row.name,
                    gift_id: row.gift_id,
                    type: row.type,
                    ticket_settlement_price: row.ticket_settlement_price,
                    a_settlement_price: row.a_settlement_price,
                    b_settlement_price: row.b_settlement_price,
                    c_settlement_price: row.c_settlement_price,
                    d_settlement_price: row.d_settlement_price,
                    time_settlement_price: row.time_settlement_price
                }
                _this.gtc_usedate_start = row.start_date
                _this.gtc_usedate_end = row.end_date
                _this.gtc_usedate_txt = row.start_date + '~' + row.end_date
				_this.gtc_usetime_start = row.start_time
				_this.gtc_usetime_end = row.end_time
				_this.gtc_usetime_txt = row.start_time + '~' + row.end_time
                _this.gtc_week_ids = row.week_cycle
                _this.gtc_week_sign = _this.gtc_week_ids.length > 0 && _this.gtc_week_ids.length < _this.week_list.length
                _this.gtc_week_all = _this.gtc_week_ids.length === _this.week_list.length
                _this.gtc_week_txt = row.week_cycle_str
                _this.showGtcEdit = true
            },
            // 适用时间
            gtcUsetime: function() {
                const _this = this;

				_this.gtc_hour_start = _this.gtc_usetime_start.split(':')[0] || '00'
				_this.gtc_minute_start = _this.gtc_usetime_start.split(':')[1] || '00'
				_this.gtc_hour_end = _this.gtc_usetime_end.split(':')[0] || '00'
				_this.gtc_minute_end = _this.gtc_usetime_end.split(':')[1] || '00'
				layer.confirm('', {
					type: 1,
					skin: 'public-alert-skin',
					btn: ['确定', '取消'], // 按钮
					title: '使用时间',
					area: ['450px', ''], // 宽高
					content: $(_this.$refs.gtc_usetime_alert)
				}, function() {
					_this.gtc_usetime_start = _this.gtc_hour_start + ":" + _this.gtc_minute_start
					_this.gtc_usetime_end = _this.gtc_hour_end + ":" + _this.gtc_minute_end
					_this.gtc_usetime_txt = _this.gtc_usetime_start + " ~ " + _this.gtc_usetime_end
					layer.closeAll();
				});
			},
			// 星期
            gtcWeekSelect() {
                const _this = this;
                const c_week_ids = _this.gtc_week_ids,
                    c_week_sign = _this.gtc_week_sign,
                    c_week_all = _this.gtc_week_all;
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择星期', true],
                    area: ['600px', ''], // 宽高
                    content: $(_this.$refs.gtc_week_alert),
                    cancel: function() {
                        // 右上角关闭
                        _this.gtc_week_ids = c_week_ids;
                        _this.gtc_week_sign = c_week_sign;
                        _this.gtc_week_all = c_week_all;
                    }
                }, function() {
                    let arr = [];
                    _this.week_list.forEach(item => {
                        _this.gtc_week_ids.forEach(sub => {
                            if(item.id == sub) {
                                arr.push(item.name);
                            }
                        });
                    });
                    _this.gtc_week_txt = arr.join(',');
                    layer.closeAll();
                }, function() {
                    _this.gtc_week_ids = c_week_ids;
                    _this.gtc_week_sign = c_week_sign;
                    _this.gtc_week_all = c_week_all;
                });
            },
            gtcWeekDel() {
				this.gtc_week_sign = false;
                this.gtc_week_all = false;
				this.gtc_week_ids = [];
            },
            gtcWeekAll(val) {
                let ids = [];
				this.week_list.forEach(v => {
					ids.push(v.id);
				});
				this.gtc_week_ids = val ? ids : [];
				this.gtc_week_sign = false;
			},
			gtcWeekChange(val) {
				const len = val.length;
				this.gtc_week_sign = len > 0 && len < this.week_list.length;
				this.gtc_week_all = len === this.week_list.length;
            },
            // 新增、修改
			gtcEdit() {
                const _this = this;

                let url = "Ticket/addRecommendGiftData"
                let data = {
                    "header": Vue.request_header,
					"request": {
						"param": {
                            "shop_id": _this.gtc_edit_form.shop_id,
                            "listorder": _this.gtc_edit_form.listorder,
                            "cost_price": _this.gtc_edit_form.cost_price,
                            "discount_price": _this.gtc_edit_form.discount_price,
                            "name": _this.gtc_edit_form.name,
                            "gift_id": _this.gtc_edit_form.gift_id,
                            "type": _this.gtc_edit_form.type,
							"start_date": _this.gtc_usedate_start,
							"end_date": _this.gtc_usedate_end,
							"start_time": _this.gtc_usetime_start,
							"end_time": _this.gtc_usetime_end,
							"week_cycle": _this.gtc_week_ids,
                            "ticket_settlement_price": _this.gtc_edit_form.ticket_settlement_price,
                            "a_settlement_price": _this.gtc_edit_form.a_settlement_price,
                            "b_settlement_price": _this.gtc_edit_form.b_settlement_price,
                            "c_settlement_price": _this.gtc_edit_form.c_settlement_price,
                            "d_settlement_price": _this.gtc_edit_form.d_settlement_price,
                            "time_settlement_price": _this.gtc_edit_form.time_settlement_price
						}
					},
					"comment": ""
                }
                if(_this.gtc_edit_id) {
                    data.request.param.id = _this.gtc_edit_id;
                    url = "Ticket/editRecommendGiftData";
                }
                Vue.axios({
                    method: 'post',
                    url: url,
                    data: data
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        layer.msg('操作成功')
						_this.getGtcTable(_this.gtc_page)
						_this.showGtcEdit = false
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                })
            },
        }
    }
</script>
<style lang="less" scoped>
    .list-tit {
        span {
            width: 100%;
            border: 1px solid #CCC;
            margin: 0 0 30px;
            line-height: 50px;
            font-size: 16px;
            text-align: center;
            cursor: pointer;
            border-radius: 10px;
        }
    }
    h1 {
        text-align: center;
    }

    .el-table {
        margin-top: 20px;
    }

    .tkt-edit-alert {
        display: none;
    }
    .select-goods-wrap {
        display: none;
    }
    .cfs-edit-row {
        .el-col {
            width: 230px;
            margin-bottom: 10px;
        }
        label {
            width: 94px;
        }
        .el-input {
            width: 120px!important;
        }
    }

    .mpl-edit {
        .el-form {
            .el-select {
                width: 400px;
            }
            .el-input {
                width: 400px;
            }
            .mpl-edit-imgs {
                position: relative;
                float: left;
                margin: 30px 30px 30px 0;
                img {
                    display: block;
                    width: 114px;
                    height: 114px;
                }
                i {
                    position: absolute;
                    right: -21px;
                    top: -21px;
                    color: #409eff;
                    font-size: 32px;
                    cursor: pointer;
                    z-index: 1999;
                }
            }
		}
    }

    .tkp-edit-alert {
        display: none;
    }

    .mtl-edit {
        .el-form {
            .el-select {
                width: 400px;
            }
            .el-input {
                width: 400px;
            }
            .mtl-edit-imgs {
                position: relative;
                float: left;
                margin: 30px 30px 30px 0;
                span {
                    margin: 0 0 0 15px;
                }
                img {
                    display: block;
                    width: 114px;
                    height: 114px;
                }
                i {
                    position: absolute;
                    right: -21px;
                    top: -21px;
                    color: #409eff;
                    font-size: 32px;
                    cursor: pointer;
                    z-index: 5;
                }
            }
            .mtl-table-input {
                width: 160px;
            }
		}
    }

    .gtc-edit {
        .el-form {
            .el-select {
                width: 400px;
            }
            .el-input {
                width: 400px;
            }
            .gtc-usedate-wrap {
                position: relative;
            }
            .gtc-usedate-main {
                width: 400px;
            }
		}
    }
</style>